import * as React from 'react'

const SvgNextArrowIcon = (props) => (
  <svg
    width="36"
    height="17"
    viewBox="0 0 36 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.19455 8.5497H34.8057M34.8057 8.5497L28.0001 15.3553M34.8057 8.5497L28.0001 1.74414"
      stroke="#98A2B3"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgNextArrowIcon
